import { Endpoint } from '../endpoint';
import { FormResponse, FormId, CompactFormResponse } from '@business/entities/form';

export function fetchForms() {
  return Endpoint.get<CompactFormResponse[]>(`@gc/forms`);
}

export function fetchForm(id: FormId) {
  return Endpoint.get<FormResponse>(`@gc/forms/form/${id}`);
}

export function createForm(data: Partial<FormResponse>) {
  return Endpoint.post<FormResponse>(`@gc/forms`, { data });
}

export function updateForm(id: FormId, data: Partial<FormResponse>) {
  return Endpoint.patch<FormResponse>(`@gc/forms/${id}`, { data });
}

export function deleteForm(id: FormId) {
  return Endpoint.delete<void>(`@gc/forms/${id}`);
}

export function duplicateForm(id: FormId, data: Partial<FormResponse>) {
  return Endpoint.post<FormResponse>(`@gc/forms/duplicate/${id}`, { data });
}

export function saveFormFields(id: FormId, data: Pick<FormResponse, 'fields'>) {
  return Endpoint.post<FormResponse>(`@gc/forms/save-fields/${id}`, { data });
}

export function deleteFormShare(id: string) {
  return Endpoint.delete<void>(`@gc/forms/delete-share/${id}`);
}
